module.exports = __webpack_public_path__ + "06_long_brown.0fafa0ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/06_long_brown.png
// module id = 5NdE
// module chunks = 0